import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "app-cbox-profile-finance-repayment-sheets-list",
  templateUrl: "./cbox-profile-finance-repayment-sheets-list.component.html",
  styleUrls: ["./cbox-profile-finance-repayment-sheets-list.component.scss"],
  standalone: true,
  imports: [
    CommonModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CBoxProfileFinanceRepaymentSheetsListComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}